import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  po_id: yup.string().required("PO number is required"),
  gr_date: yup.string().required("GRN date is required"),
  items: yup.array().of(
    yup.object().shape({
      quantity_received: yup.string().required("Quantity is required"),
    }),
  ),
});

export const useValidation = ({ ...params }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...params,
    },
  });
};
